import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Fade, Tooltip, CircularProgress, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { green, red, grey, orange, amber, cyan } from '@mui/material/colors';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import {useHistory} from "react-router-dom";
import { ROUTES } from 'consts';
import moment from 'moment';

const ToolTipStyle = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.primary.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: '4px',
    backgroundColor: theme.palette.primary.light,
  },
}));

//STATUS: OK, ER, AB, NE, WA, RU

export default function JobStatus({
  status='OK',
  job,
  size='medium',
  sx
}) {
  const history = useHistory();
  const [t] = useTranslation();
  let Icon = CheckCircleIcon;
  let color = green[500];
  let animation = {};

  const handleOnClick = ()=>{
    if (job){
      history.push(`${ROUTES.JOB_RUN_WORKFLOW}/${job.job_id}`);
    }
  }

  const IconComponent = () => {
    let runningSize = size;
    if (size === 'small') runningSize = 16;
    else if (size === 'medium') runningSize = 20;
    else if (size === 'large') runningSize = 30;

    if (status === 'ER') {
      Icon = CancelIcon;
      color = red[500];
    }
    if (status === 'AB') {
      Icon = RemoveCircleIcon;
      color = grey[500];
    }
    if (status === 'NE') {
      Icon = RemoveCircleIcon;
      color = orange[500];
    }
    if (status === 'WA') {
      Icon = WatchLaterIcon;
      color = amber[500];
    }

    return (
      <>
        { status === 'RU' ?
          (
            <Box
              sx={{
                width: runningSize + 4,
                height: runningSize + 4,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                outline: `6px solid ${cyan[100]}`,
                outlineOffset: -8,
                borderRadius: '100%'
              }}
            >
              <CircularProgress
                disableShrink
                size={runningSize}
                thickness={8}
                sx={{ color: cyan[500] }}
              />
            </Box>
          )
          :(
            <Icon fontSize={size} sx={{ color }}/>
          )
        }
      </>
    )
  }
  const formatText = ()=>{
    let retorna = "";
    try{
      retorna = job.job_id;
      retorna += " - "+moment(job.created).add(-3, 'hours').format('DD/MM HH:mm');

    }catch(err){
      
    }

    return retorna;
  }



  return (
    <ToolTipStyle
      arrow
      disableFocusListener
      placement="top-start"
      title={formatText()}
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      enterDelay={700}
    >
      <IconButton
        aria-label={status}
        size="small"
        onClick={ handleOnClick ? () => handleOnClick() : () => {}}
        sx={{ p: 0, m: 0, backgroundColor: 'white', ...sx, ...animation }}
      >
        <IconComponent />
      </IconButton>
    </ToolTipStyle>
  );
}
